import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';

const initApp = async () => {
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('mode') as 'widget' | 'dashboard' | 'landing' || 'landing';
  const projectId = params.get('project');

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App mode={mode} projectId={projectId || ''} />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

initApp();